/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pretty_Large_Mink_BuildInputs */

const fr_pretty_large_mink_build = /** @type {(inputs: Pretty_Large_Mink_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WOD`)
};

/**

* @param {Pretty_Large_Mink_BuildInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pretty_large_mink_build = /** @type {((inputs?: Pretty_Large_Mink_BuildInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pretty_Large_Mink_BuildInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pretty_large_mink_build(inputs)
});